import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=77690dca&scoped=true"
import script from "./marquee.vue?vue&type=script&lang=js"
export * from "./marquee.vue?vue&type=script&lang=js"
import style0 from "./marquee.vue?vue&type=style&index=0&id=77690dca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77690dca",
  null
  
)

export default component.exports